<template>
  <div class="container">
    <div class="main">
      <div class="title wow fadeInUp">供应链合作伙伴</div>
      <div class="list wow fadeInUp" ref="list">
        <div class="rowup cc">
            <img class="list-item" v-for="(item, index) in list" :key="index" :src="item.img" />
            <img class="list-item" v-for="(item, index) in list" :key="index" :src="item.img" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { img: require("@/assets/home/partner/01.png") },
        { img: require("@/assets/home/partner/02.png") },
        { img: require("@/assets/home/partner/03.png") },
        { img: require("@/assets/home/partner/04.png") },
        { img: require("@/assets/home/partner/05.png") },
        { img: require("@/assets/home/partner/06.png") },
        { img: require("@/assets/home/partner/07.png") },
        { img: require("@/assets/home/partner/08.png") },
        { img: require("@/assets/home/partner/09.png") },
      ],
      current: 0,
      time: null,
    };
  },
  methods: {
    // addAnimate() {
    //   let { current, addAnimate, list } = this;
    //   let animation = this.$refs.list.animate(
    //     [
    //       { transform: `translateX(${-450 * current}px)` },
    //       { transform: `translateX(${-450 * (current + 1)}px)` },
    //     ],
    //     {
    //       duration: 3000,
    //       "fill-mode": "forwards",
    //       "timing-function": "linear",
    //       delay: "1000",
    //     }
    //   );
    //   // this.current++;
    //   // if(this.current === list.length)this.current=0
    //   this.current = ++this.current % list.length;
    //   animation.addEventListener(
    //     "finish",
    //     function () {
    //       addAnimate();
    //     },
    //     false
    //   );
    // },
  },
  mounted() {
    // this.addAnimate();
    // let { list } = this;
    // let _this = this;
    // this.time = setInterval(() => {
    //   if (this.current === list.length) {
    //     _this.current = 0;
    //     this.$refs.list.style.transition = "none";
    //     this.$refs.list.style.transform = `translateX(0px)`;
    //   } else {
    //     this.current++;
    //     this.$refs.list.style.transition = "all 3s linear";
    //     this.$refs.list.style.transform = `translateX(${
    //       -355 * this.current
    //     }px)`;
    //   }
    // }, 3000);
  },
  unmounted() {
    this.time && clearInterval(this.time);
  },
};
</script>
<style lang="scss" scoped>
@mixin searchWidth($searchWidth) {
  .container {
    flex-grow: 1;
    display: flex;
    align-items: center;
    background: linear-gradient(180deg, #F8FAFB 0%, #FAFAFA 100%);
    width: 100%;
  }

  .main {
    //background: linear-gradient(180deg, #f4f4f5 0%, #e5e6e8 100%);

    overflow: hidden;
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-direction: column;

    @if ($searchWidth<1100) {
    } @else {
      height: 3.15rem;
    }
  }

  .title {
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    letter-spacing: 0.01rem;
    margin-bottom:  0.5rem ;

    @if ($searchWidth<1100) {
      font-size: 1rem;
      padding-top: 1rem;
    } @else {
      font-size: 0.44rem;
      padding-top: 0.6rem;
      line-height: 0.6rem;
    }
  }

  .list {
    display: flex;
    align-self: flex-start;
    transform: translateX(0px);
    //transition: all 3s;
  }

  .list-item {
    display: flex;
    align-items: center;
    justify-content: center;

    @if ($searchWidth<1100) {
      width: 9.25rem;
      height: 3.25rem;
      border-radius: 0.5rem;
      margin: 0 0.3rem 1.5rem;

      img {
        // width: 6.25rem;
        width: 100%;
      }
    } @else {
      width: 2.4rem;
      height: 0.92rem;
      border-radius: 0.16rem;
      margin: 0 0.1rem;

      img {
        width: 100%;
      }
    }
  }

  @keyframes rowup {
    to{
      transform: translateX(-50%);
    }
  }

  //.list {
  //  width: 300px;
  //  border: 1px solid #999;
  //  margin: 20px auto;
  //  position: relative;
  //  height: 200px;
  //  overflow: hidden;
  //}

  .list .rowup {
    animation: 30s rowup linear infinite normal;
    position: relative;
    display: flex;
  }
}

@media (max-width: 1100px) {
  @include searchWidth(999);
}

@media (min-width: 1100px) {
  @include searchWidth(1101);
}
</style>
